import { type FC, useMemo } from 'react';
import StatCard from './StatCard';
import FilterBadge, { EmptyFilterState } from './FilterBadge';
import { useStatisticsData } from '@/pages/statistics/StatisticsDataContext';

const StatsOverview: FC = () => {
  const { statsSummary, loading, advancedFilters, resetFilters } = useStatisticsData();

  const filterKey = useMemo(() => {
    return `${advancedFilters.numberRanges.join(',')}|${advancedFilters.dayOfWeeks.join(',')}|${advancedFilters.prizeRange}`;
  }, [advancedFilters]);

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="bg-background-100/80 border border-background-200/60 rounded-2xl p-6 animate-pulse">
            <div className="h-4 bg-background-200 rounded w-20 mb-3"></div>
            <div className="h-8 bg-background-200 rounded w-16 mb-2"></div>
            <div className="h-3 bg-background-200 rounded w-24"></div>
          </div>
        ))}
      </div>
    );
  }

  if (!statsSummary) {
    return (
      <div>
        <div className="mb-3">
          <FilterBadge advancedFilters={advancedFilters} onReset={resetFilters} />
        </div>
        <EmptyFilterState />
      </div>
    );
  }

  return (
    <div>
      <div className="mb-3">
        <FilterBadge advancedFilters={advancedFilters} onReset={resetFilters} />
      </div>
      <div key={filterKey} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 animate-[contentFadeIn_0.35s_ease-out]">
        <StatCard
          icon="ri-history-line"
          label="분석한 총 회차"
          value={`${statsSummary.totalDraws}회`}
          sub={`최근 ${statsSummary.latestDraw}회차까지`}
        />
        <StatCard
          icon="ri-fire-line"
          label="가장 많이 나온 번호"
          value={statsSummary.hottestNumber}
          sub={`총 ${statsSummary.hottestCount}회 출현`}
          accent
        />
        <StatCard
          icon="ri-snowy-line"
          label="가장 적게 나온 번호"
          value={statsSummary.coldestNumber}
          sub={`총 ${statsSummary.coldestCount}회 출현`}
        />
        <StatCard
          icon="ri-donut-chart-line"
          label="번호당 평균 출현"
          value={`${statsSummary.averagePerNumber}회`}
          sub="이론적 기대 출현 횟수"
        />
      </div>
    </div>
  );
};

export default StatsOverview;